(function () {
  "use strict";

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_RE = /^[0-9\-\+\s()]{7,}$/;

  /* Built at runtime so a browser without unicode property escapes doesn't
     throw a parse error — it just falls back to the digit/symbol check. */
  var NAME_RE = null;
  try {
    NAME_RE = new RegExp("^[\\p{L}\\p{M}][\\p{L}\\p{M}\\s'.-]*$", "u");
  } catch (e) {
    NAME_RE = null;
  }
  var NAME_BAD_RE = /[0-9_@#$%^&*()!?\/\\|<>{}[\]=+~`]/;

  var MESSAGES = {
    name: {
      empty: "Enter your name",
      short: "Name is too short",
      invalid: "Letters only, please",
    },
    email: {
      empty: "Enter your email address",
      invalid: "Enter a valid email address",
    },
    phone: {
      invalid: "Enter a valid phone number",
    },
    body: {
      empty: "Let us know how we can help",
      short: "Please add a little more detail",
    },
  };

  /* Returns an error string for the field, or "" when it is valid. */
  function validate(input) {
    var key = input.getAttribute("data-lpc-label");
    var value = (input.value || "").trim();
    var m = MESSAGES[key] || {};

    switch (key) {
      case "name":
        if (!value) return m.empty;
        if (value.replace(/[\s'.-]/g, "").length < 2) return m.short;
        if (NAME_RE ? !NAME_RE.test(value) : NAME_BAD_RE.test(value)) {
          return m.invalid;
        }
        return "";
      case "email":
        if (!value) return m.empty;
        if (!EMAIL_RE.test(value)) return m.invalid;
        return "";
      case "phone":
        if (!value) return ""; // optional
        if (!PHONE_RE.test(value)) return m.invalid;
        return "";
      case "body":
        if (!value) return m.empty;
        if (value.length < 10) return m.short;
        return "";
      default:
        return "";
    }
  }

  function fieldWrap(input) {
    return input.closest("[data-lpc-field]");
  }

  function showError(input, message) {
    var wrap = fieldWrap(input);
    var slot = document.getElementById(input.getAttribute("aria-describedby"));
    if (wrap) wrap.classList.add("lpc__field--error");
    if (slot) slot.textContent = message;
    input.setAttribute("aria-invalid", "true");
  }

  function clearError(input) {
    var wrap = fieldWrap(input);
    var slot = document.getElementById(input.getAttribute("aria-describedby"));
    if (wrap) wrap.classList.remove("lpc__field--error");
    if (slot) slot.textContent = "";
    input.removeAttribute("aria-invalid");
  }

  function refresh(input) {
    var message = validate(input);
    if (message) showError(input, message);
    else clearError(input);
    return !message;
  }

  function initForm(form) {
    if (form.dataset.lpcValidateBound) return;
    form.dataset.lpcValidateBound = "1";

    /* Take over from native validation so the messaging is consistent. */
    form.noValidate = true;

    var inputs = Array.prototype.slice.call(
      form.querySelectorAll("[data-lpc-input]")
    );
    if (!inputs.length) return;

    var submitted = false;

    inputs.forEach(function (input) {
      /* Validate on blur once the field has been touched, and after the
         first submit attempt keep it live as the visitor types. */
      input.addEventListener("blur", function () {
        if (input.value.trim() !== "" || submitted) refresh(input);
      });
      input.addEventListener("input", function () {
        var wrap = fieldWrap(input);
        if (submitted || (wrap && wrap.classList.contains("lpc__field--error"))) {
          refresh(input);
        }
      });
    });

    form.addEventListener("submit", function (e) {
      submitted = true;
      var firstInvalid = null;

      inputs.forEach(function (input) {
        if (!refresh(input) && !firstInvalid) firstInvalid = input;
      });

      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
        if (typeof firstInvalid.scrollIntoView === "function") {
          firstInvalid.scrollIntoView({ block: "center", behavior: "smooth" });
        }
      }
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll(".lpc__form")
      .forEach(function (form) {
        initForm(form);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
